module.exports = __webpack_public_path__ + "static/Lionsgate Play-d340f795050ded463b0e4a7a75205815.png";